var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 13.125C12.5 12.2528 12.5 11.8167 12.3924 11.4618C12.15 10.6628 11.5247 10.0375 10.7257 9.79515C10.3708 9.6875 9.93473 9.6875 9.0625 9.6875H5.9375C5.06527 9.6875 4.62916 9.6875 4.27429 9.79515C3.47528 10.0375 2.85003 10.6628 2.60765 11.4618C2.5 11.8167 2.5 12.2528 2.5 13.125M10.3125 4.6875C10.3125 6.2408 9.0533 7.5 7.5 7.5C5.9467 7.5 4.6875 6.2408 4.6875 4.6875C4.6875 3.1342 5.9467 1.875 7.5 1.875C9.0533 1.875 10.3125 3.1342 10.3125 4.6875Z",
    stroke: "#898F9D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGender);
export default __webpack_public_path__ + "static/media/gender.92ef6d56a75ca326470f3866e0c00188.svg";
export { ForwardRef as ReactComponent };